/* eslint-disable no-use-before-define */
import React, { useCallback, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import AutoComplete from '@material-ui/lab/Autocomplete'
import { Props } from './AppBar'
import { sortBy } from 'lodash'
import placeholder from '../data/kommundataPlaceholder'
import kommundata from '../data/kommundata2022'

export interface MunicipalityData {
    municipality: string
    voters: string
    votingareas: string
    participation: string
    registeredVoters: string
}

const municipalityData: MunicipalityData[] = sortBy(
    kommundata,
    (obj) => obj.municipality
)

const randomNumber = Math.random()

const changeMunicipality = (
    data: MunicipalityData | null,
    setActiveMunicipality: (data: MunicipalityData) => void,
    setMedVotes: (val: number) => void
) => {
    setActiveMunicipality(data || placeholder)
    setMedVotes(
        Math.floor(
            randomNumber *
                Number(data?.voters) *
                (Number(data?.votingareas) > 0 ? 0.03 : 0.02)
        ) || 5
    )
}

export default function ComboBox(props: Props) {
    const handleMunicipalityChange = useCallback(
        (data: MunicipalityData | null) => {
            // Memoize function so it doesn't reload on each rerender but still has access to inner state.
            changeMunicipality(
                data,
                props.setActiveMunicipality,
                props.setMedVotes
            )
            if (data) props.setActiveMunicipality(data)
        },
        [props]
    )

    useEffect(() => {
        handleMunicipalityChange(props.activeMunicipality)
    }, [handleMunicipalityChange, props.activeMunicipality])

    return (
        <AutoComplete
            id="Kommun"
            options={municipalityData}
            getOptionLabel={(option: { municipality: string }) =>
                option.municipality
            }
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            style={{
                display: 'grid',
                width: 'clamp(4rem, 80vmin, 50rem)',
                borderRadius: 10,
                margin: '3vmin',
                backgroundColor: 'white',
            }}
            renderInput={(params: any) => {
                const label = props.activeMunicipality.municipality
                return (
                    <TextField {...params} label={label} variant="outlined" />
                )
            }}
            onChange={(_, obj) => {
                handleMunicipalityChange(obj)
            }}
        />
    )
}
